import SkeletonLoading from './SkeletonLoading'

export default SkeletonLoading
